import { h, render, Component } from 'preact';

export class PickDeviceOS extends Component {

  chooseDeviceOS = os => e => {
    var nextScreen = 'installApp';
    if(this.props.deviceType == 'mobile') {
      nextScreen = 'registerNumber';
    }
    this.props.updateWizard({
      screen: nextScreen,
      deviceOS: os
    });
  }

  render(props, state) {
		return (
      <div class="touchOptions">
        <div class="touchBtn" onClick={this.chooseDeviceOS('ios')}><i class="fa fa-apple fa-3x"></i><div>iOS</div></div>
        <div class="touchBtn" onClick={this.chooseDeviceOS('android')}><i class="fa fa-android fa-3x"></i><div>Android</div></div>
      </div>
		)
  }
}
